/* La Caza Cali — Shop by Room interactivity
 *
 * Hover/click on a room item swaps the active image, overlay text, and
 * Shop CTA via class-toggle (CSS handles the crossfade transition).
 * Scoped per [data-lacaza-rooms] container — works with multiple instances.
 */
(function () {
  'use strict';

  function initRooms(root) {
    var triggers = root.querySelectorAll('[data-lacaza-room-trigger]');
    if (!triggers.length) return;

    function setActive(idx) {
      var idxStr = String(idx);
      var activeTrigger = null;
      triggers.forEach(function (btn) {
        var on = btn.getAttribute('data-lacaza-room-trigger') === idxStr;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on) activeTrigger = btn;
      });
      root.querySelectorAll('[data-lacaza-room-img]').forEach(function (el) {
        el.classList.toggle('is-active', el.getAttribute('data-lacaza-room-img') === idxStr);
      });
      root.querySelectorAll('[data-lacaza-room-overlay]').forEach(function (el) {
        el.classList.toggle('is-active', el.getAttribute('data-lacaza-room-overlay') === idxStr);
      });
      root.querySelectorAll('[data-lacaza-room-cta]').forEach(function (el) {
        el.classList.toggle('is-active', el.getAttribute('data-lacaza-room-cta') === idxStr);
      });
      // Each CTA has its own href baked in from Liquid (one CTA per
      // room block), but mirror the active room's url onto the active
      // CTA defensively — supports a future "single shared CTA" pattern
      // and keeps the rendered href in sync if blocks change at runtime.
      if (activeTrigger) {
        var url = activeTrigger.getAttribute('data-lacaza-room-url') || '#';
        var activeCta = root.querySelector('[data-lacaza-room-cta="' + idxStr + '"]');
        if (activeCta && url !== '#') activeCta.setAttribute('href', url);
      }
    }

    triggers.forEach(function (btn) {
      var idx = btn.getAttribute('data-lacaza-room-trigger');
      btn.addEventListener('mouseenter', function () { setActive(idx); });
      btn.addEventListener('focus', function () { setActive(idx); });
      btn.addEventListener('click', function (e) {
        // Don't navigate — just activate. CTA in overlay handles navigation.
        e.preventDefault();
        setActive(idx);
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-lacaza-rooms]').forEach(initRooms);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
